import familyHttp from "./familyHttp";

const API_PREFIX = "/web/family";

function unwrapResponse(res) {
  const body = res && res.data;
  if (!body || typeof body !== "object" || Array.isArray(body)) {
    return { ok: false, message: "服务无响应" };
  }
  if (body.success || body.code === 1) {
    return { ok: true, data: body.data, message: body.msg };
  }
  return { ok: false, message: body.msg || "请求失败" };
}

export const familyHomeApi = {
  async load() {
    const res = await familyHttp.get(`${API_PREFIX}/home`);
    const result = unwrapResponse(res);
    if (!result.ok) {
      throw new Error(result.message);
    }
    return result.data || {
      stats: [],
      overallRating: "5.0",
      starCaregivers: [],
      latestReviews: [],
    };
  },

  async caregiverProfile(id) {
    const res = await familyHttp.get(`${API_PREFIX}/caregivers/${id}/profile`);
    const result = unwrapResponse(res);
    if (!result.ok) {
      throw new Error(result.message);
    }
    return result.data;
  },
};
